import React, { useEffect, useState, useRef } from "react";
import Leftbar from "../Containers/DashboardContainer/Component/Leftbar";
import "./NewEpisodes.scss";
import Actions from "../Actions/Creators";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

import comimg from "../Containers/DashboardContainer/Component/NewUiimg/Complaint.png";
import sign from "../Containers/DashboardContainer/Component/NewUiimg/sign.png";
import sugges from "../Containers/DashboardContainer/Component/NewUiimg/sugges.png";
import remarks from "../Containers/DashboardContainer/Component/NewUiimg/remarks.png";
import upar from "../Containers/DashboardContainer/Component/NewUiimg/upar.png";
import dwn from "../Containers/DashboardContainer/Component/NewUiimg/dwnar.png";
import Pagination from "../Containers/HSGPagination/HSGPagination";
import nodata from "./nodata.png";

import stuicon from "../Containers/DashboardContainer/Component/NewUiimg/stu_listicon.png";
import RootLayout from "../Components/shared/RootLayout";
import BackButton from "../Components/shared/BackButton";

const NewEpisodes = withRouter((props) => {
  const [expanded, setExpanded] = useState([true]);

  const expandedBlockRef = useRef(null); // Ref to the expanded block

  const buildHeader = (newHeader, oldHeader) =>
    Object.assign({}, oldHeader, newHeader);

  const { inOffset, data, total, className, buildEpisodeHeader } = props;
  // const [currentPage, setCurrentPage] = useState(0);
  const limitPerPage = 5;

  const getStartNode = (billingId, s_Map) => {
    for (let eachProgram in s_Map) {
      if (s_Map[eachProgram].billing_id === billingId) return eachProgram;
    }
    return false;
  };

  useEffect(() => {
    fetchData(0); // Fetch initial data when component mounts
    props.fetchNurseMeta();
  }, []);

  const shouldRenderBlock = () => {
    const { med_complaint, med_suggestion, med_symptoms, med_remarks } =
      episode.episode_custom_json || {};
    return (
      med_complaint !== "N.A" ||
      med_suggestion !== "N.A" ||
      med_symptoms !== "N.A" ||
      med_remarks !== "N.A"
    );
  };

  const fetchData = async (offset) => {
    // Set loader visibility to true when fetching data
    props.setLoader();

    // Introduce a delay to allow the loader to appear before fetching data
    await new Promise((resolve) => setTimeout(resolve, 300)); // Adjust the delay time as needed

    try {
      // Call fetchEpisodeSearch and wait for it to resolve
      await props.fetchEpisodeSearch({
        inOrganizationId: props.organizationId,
        inOffset: offset,
        inLimit: limitPerPage,
        // eventTrackId: 11623,
      });
    } catch (error) {
      // Log the error if fetchEpisodeSearch fails
      console.error("Error fetching episode data:", error);
    } finally {
      // Unset loader after data is fetched or if an error occurs
      props.unsetLoader();
    }
  };

  useEffect(() => {
    // setIsLoading(false); // Set loader visibility to false when data fetching is complete
  }, [props.episodeList]); // Assuming props.episodeList indicates that data fetching is complete

  const showNext = (where) => {
    let newOffset;
    if (where === "prev") {
      newOffset = Math.max(0, props.episodeHeader.inOffset - limitPerPage);
    } else {
      newOffset = props.episodeHeader.inOffset + limitPerPage;
    }
    fetchData(newOffset);
  };

  function getCenteredInitials(name) {
    const names = name.split(" ");
    if (names.length < 2) {
      return names[0].charAt(0).toUpperCase();
    } else {
      const firstNameInitial = names[0].charAt(0).toUpperCase();
      const lastNameInitial = names[names.length - 1].charAt(0).toUpperCase();
      return firstNameInitial + lastNameInitial;
    }
  }

  const redirectToStudentProfile = (episode) => {
    let NEW_CLINIC_STU = {
      admission_number: episode.admission_number,
      class: episode.class,

      student_id: episode.student_id,
      uuid: episode.uuid,
      gender: episode.gender,

      dob: episode.dob,

      //    startNodeMap: props.startNodeMap[props.currentProgram.billing.id].id,

      name: getInitials(episode.name),
    };

    props.setSelectedStudent(NEW_CLINIC_STU);

    sessionStorage.setItem("student", JSON.stringify(episode));

    props.history.push("/student-profile");
  };

  const renderPagination = (className) => {
    const { episodeHeader, episodeList, episodeTotal } = props;

    return episodeList && episodeList.length ? (
      <Pagination
        inOffset={episodeHeader.inOffset}
        showNext={showNext}
        data={episodeList}
        total={episodeTotal}
        className={className}
      />
    ) : null;
  };

  const getStudentColor = (name) => {
    const colors = [
      "#FDE68A",
      "#BFDBFE",
      "#C7D2FE",
      "#DDD6FE",
      "#FBCFE8",
      "#A7F3D0",
      "#BAE6FD",
      "#FED7AA",
      "#FECACA",
      "#D9F99D",
    ];

    let hash = 0;

    for (let i = 0; i < name.length; i++) {
      hash = name.charCodeAt(i) + ((hash << 5) - hash);
    }

    const index = Math.abs(hash) % colors.length;

    return colors[index];
  };

  function isDarkColor(color) {
    // Convert hex color to RGB
    color = color?.substring(1); // Remove #
    const rgb = parseInt(color, 16);
    const r = (rgb >> 16) & 0xff; // Extract red
    const g = (rgb >> 8) & 0xff; // Extract green
    const b = (rgb >> 0) & 0xff; // Extract blue

    // Calculate luminance
    const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

    // Check if color is dark
    return luminance < 128;
  }

  function getInitials(name) {
    const nameArray = name?.split(" ");
    const firstName = nameArray?.[0]?.charAt(0)?.toUpperCase() || "";
    const lastName =
      nameArray?.[nameArray.length - 1]?.charAt(0)?.toUpperCase() || "";
    return firstName + lastName;
  }

  const goBack = () => {
    window.history.back();
  };

  const toggleExpanded = (index) => {
    setExpanded((prevExpanded) => {
      const newExpanded = { ...prevExpanded };
      Object.keys(newExpanded).forEach((key) => {
        if (key !== index.toString()) {
          newExpanded[key] = false;
        }
      });
      newExpanded[index] = !prevExpanded[index];
      return newExpanded;
    });

    // Scroll the expanded block into view after a short delay, regardless of expanding or collapsing
    setTimeout(() => {
      const blockRef = expandedBlockRef.current;
      if (blockRef) {
        blockRef.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }, 100);
  };

  const isValidDate = (date) => {
    return date && !isNaN(new Date(date).getTime());
  };

  return (
    <RootLayout props={props}>
      <div
        style={{
          display: "flex",
          padding: "1em 1.3rem",
          flexDirection: "column",
          gap: "2rem",
        }}
      >
        {props.episodeList && props.episodeList.length > 0 ? (
          <div className="col-md-12 ">
            <div style={{ paddingBottom: "1.5rem" }}>
              <BackButton />
            </div>
            <div className="episodes-container ">
              {props?.episodeList?.map((episode, index) => (
                <div
                  key={index}
                  className="episodes_card mb-5   borderRadius   "
                  style={{
                    height: expanded[index] ? "600px" : "230px",
                    flex: 1,
                    flexDirection: "column",

                    padding: "10px",
                  }}
                >
                  <div
                    style={{
                      flexDirection: "row",
                      display: "flex",
                      gap: 20,
                      padding: "0px 10px",

                      alignItems: "center",
                    }}
                  >
                    {/* profile */}

                    <h1
                      className="under_circlenameNew  circle "
                      style={{
                        backgroundColor: getStudentColor(episode?.name || ""),
                        color: isDarkColor() ? "#000" : "#000",
                      }}
                    >
                      {getInitials(episode?.name)}{" "}
                    </h1>

                    {/* sub col */}
                    <div
                      style={{
                        flex: 1,
                        display: "flex",
                        flexDirection: "column ",
                      }}
                    >
                      {/* row 1 */}
                      <div style={{ display: "flex", flexDirection: "row" }}>
                        <div style={{ flex: 1 }}>
                          {" "}
                          <h1
                            className="name_boldNew "
                            style={{ width: "100%" }}
                          >
                            {episode.name
                              .split(" ")
                              .map((part, index) =>
                                index === 0
                                  ? part.charAt(0).toUpperCase() +
                                    part.slice(1).toLowerCase()
                                  : part.charAt(0).toUpperCase() +
                                    part.slice(1).toLowerCase(),
                              )
                              .join(" ")}
                          </h1>
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <div
                            type="button"
                            onClick={() => redirectToStudentProfile(episode)}
                            className="viewprofilebtn d-flex justify-content-center  gap-4"
                            style={{
                              flexDirection: "row",
                              alignItems: "center",
                            }}
                          >
                            <img
                              style={{ width: "20px" }}
                              className="stuicon2"
                              src={stuicon}
                            />
                            <p className="view-profile-btn-txt pt-2">
                              View Profile
                            </p>
                          </div>

                          <h1 className="episodeTimeV2  d-flex  ">
                            {(() => {
                              const rawDate =
                                episode.episode_custom_json.med_created;
                              const date = new Date(rawDate);

                              const months = [
                                "Jan",
                                "Feb",
                                "Mar",
                                "Apr",
                                "May",
                                "Jun",
                                "Jul",
                                "Aug",
                                "Sep",
                                "Oct",
                                "Nov",
                                "Dec",
                              ];

                              const day = date.getDate();
                              const month = months[date.getMonth()];
                              const year = date.getFullYear();
                              let hours = date.getHours();
                              let minutes = date.getMinutes();

                              hours = (hours < 10 ? "0" : "") + hours;
                              minutes = (minutes < 10 ? "0" : "") + minutes;

                              return `${day} ${month} ${year}, ${hours}:${minutes}`;
                            })()}
                          </h1>
                        </div>
                      </div>
                      {/* row 2 */}

                      <div
                        style={{
                          display: "flex",
                          alignItems: "flex-start",
                          justifyContent: "space-between",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "30px",
                          }}
                        >
                          <p>Class: {episode.class}</p>
                          <p>Section: {episode.section}</p>
                          <p>Gender: {episode.gender}</p>
                          <p>DOB: {episode.dob}</p>
                        </div>
                        <p>Admission Number: {episode.admission_number}</p>
                      </div>
                    </div>
                  </div>
                  <div className="row ">
                    <div
                      className="col-md-12 settingheihgt p-0"
                      style={{ marginBottom: "28px", marginTop: "0px" }}
                    >
                      <div className="col-md-12 d-flex justify-content-center  episodeTimelineBlock">
                        <div
                          className="col-md-12"
                          ref={expanded[index] ? expandedBlockRef : null}
                        >
                          <div className="col-md-6 my-3 nursename"></div>
                          <div className="col-md-6 my-3 d-flex justify-content-end ">
                            <button
                              className="btn btn-link"
                              onClick={() => toggleExpanded(index)}
                              aria-controls={`collapseContent${index}`}
                              aria-expanded={expanded[index]}
                              style={{
                                marginTop: "4px",
                                marginBottom: "-13px",
                              }}
                            >
                              {expanded[index] ? (
                                <img
                                  className="upepisodearrow"
                                  src={upar}
                                  alt="Up Arrow"
                                />
                              ) : (
                                <img
                                  className="downepisodearrow"
                                  src={dwn}
                                  alt="Down Arrow"
                                />
                              )}
                            </button>
                          </div>

                          <div
                            className={`collapse ${
                              expanded[index] ? "show" : ""
                            }`}
                            id={`collapseContent${index}`}
                          >
                            <div className="row">
                              <div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="my-2">
                                    <img className="com_img" src={comimg}></img>
                                    <span
                                      className="mx-2"
                                      style={{
                                        color: "#1E87F0",
                                        fontWeight: 500,
                                        width: "50%",
                                      }}
                                    >
                                      Complaints
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-11 block-xtv2  my-2 mb-3"
                                    style={{ width: "100%" }}
                                  >
                                    <p className="nursename-txt my-3">
                                      {episode.episode_custom_json
                                        ?.med_complaint || "N.A"}
                                    </p>
                                  </div>
                                </div>

                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="my-2">
                                    <img className="com_img" src={sugges}></img>
                                    <span
                                      className="mx-2"
                                      style={{
                                        color: "#1E87F0",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Treatment Suggestions
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-11 block-xtv2  my-2 mb-3"
                                    style={{ width: "100%" }}
                                  >
                                    <p className="nursename-txt my-3">
                                      {episode.episode_custom_json
                                        ?.med_suggestion || "N.A"}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="my-2">
                                    <img className="com_img" src={sign}></img>
                                    <span
                                      className=" mx-2"
                                      style={{
                                        color: "#1E87F0",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Sign & Symptoms
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-11 block-xtv2  my-2 mb-3"
                                    style={{ width: "100%" }}
                                  >
                                    <p className="nursename-txt my-3">
                                      {episode.episode_custom_json
                                        ?.med_symptoms || "N.A"}
                                    </p>
                                  </div>
                                </div>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                  }}
                                >
                                  <div className="my-2">
                                    <img
                                      className="com_img"
                                      src={remarks}
                                    ></img>
                                    <span
                                      className="mx-2"
                                      style={{
                                        color: "#1E87F0",
                                        fontWeight: 500,
                                      }}
                                    >
                                      Remarks
                                    </span>
                                  </div>
                                  <div
                                    className="col-md-11 block-xtv2  my-2 mb-3"
                                    style={{ width: "100%" }}
                                  >
                                    <p className="nursename-txt my-3">
                                      {episode.episode_custom_json
                                        ?.med_remarks || "N.A"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>

            <div className="col-md-12 col-sm-12 col-xs-12 padding-10">
              {renderPagination("hsg-dashboard-pagination-bottom right")}
            </div>
          </div>
        ) : (
          <React.Fragment>
            <div
              style={{ display: props?.isLoading ? "none" : "" }}
              className="container"
            >
              <div
                className="col-md-12 justify-content-center rownodata "
                style={{ background: "white" }}
              >
                <div className=" d-flex justify-content-center align-items-center  imageadjust">
                  <div className="col-md-2 text-center ">
                    <img className="nodata " src={nodata} alt="No Data" />
                    <p className="nodatatxt  d-flex justify-content-center align-items-center ">
                      OOPS! Data is not available.
                    </p>
                  </div>
                  <div className="col-md-2">
                    <button className="btn-nodata" onClick={goBack}>
                      <p className="goback">Go Back</p>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </React.Fragment>
        )}
      </div>
    </RootLayout>
  );
});

const mapStateToProps = (state) => ({
  isLoading: state.auth.isLoading,
});
const mapDispatchToProps = (dispatch) => ({
  setLoader: (msg) => dispatch(Actions.setLoader(msg)),
  unsetLoader: () => dispatch(Actions.unsetLoader()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(NewEpisodes));
